// plugins/ImageUrlRevokePlugin.tsx
import { useEffect, useRef } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getNodeByKey } from 'lexical';
import { ImageNode } from '../nodes/ImageNode';
import { addImageRef, releaseImageRef } from '@/src/utils';

export default function ImageUrlRevokePlugin() {
    const [editor] = useLexicalComposerContext();
    const keyToGuid = useRef(new Map<string, string | null>());

    useEffect(() => {
        return editor.registerMutationListener(ImageNode, (mutations) => {
            editor.getEditorState().read(() => {
                mutations.forEach((type, nodeKey) => {
                    const key = String(nodeKey);
                    if (type === 'created' || type === 'updated') {
                        const node = $getNodeByKey(nodeKey);
                        if (!node) return;

                        const src: string = (node as any).__src;
                        const newGuid = src?.startsWith('local://')
                            ? src.slice('local://'.length)
                            : null;
                        const prevGuid = keyToGuid.current.get(key) ?? null;

                        if (prevGuid !== newGuid) {
                            if (prevGuid) releaseImageRef(prevGuid);
                            if (newGuid) addImageRef(newGuid);
                            keyToGuid.current.set(key, newGuid);
                        }
                    } else if (type === 'destroyed') {
                        const prevGuid = keyToGuid.current.get(key);
                        if (prevGuid) releaseImageRef(prevGuid);
                        keyToGuid.current.delete(key);
                    }
                });
            });
        });
    }, [editor]);

    return null;
}
